/**
 * 组件导出
 * @author wangdi
 */

import message from './src/message';
import messageBox from './src/messageBox';
import $Loading from  './src/loading';

const $Dialog = {
    notify: message.notify,
    soundNotify: message.soundNotify,
    alert: messageBox.alert,
    confirm: messageBox.confirm
};
export {$Dialog,$Loading};
// 简化调用方法
export {notify, soundNotify} from './src/message';
export {alert, confrim} from './src/messageBox';
